import { Box, Flex, Text } from '@chakra-ui/react'
import jwtDecode from 'jwt-decode'
import React, { useEffect, useState,useRef } from 'react'
import { BsExclamationSquareFill } from 'react-icons/bs'
import { Bar, BarChart, CartesianGrid, Label, Legend, Pie, PieChart, Tooltip, XAxis, YAxis } from 'recharts'
import DashboardBox from '../Components/DashboardBox'
import Preloader from '../Components/Preloader'
import MainLayout from '../Layouts/Index'
import { GetAllStores, GetDashboard } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'

export default function Dashboard() {

  const [Store, setStore] = useState([])
   
  let ImsToken = JSON.parse(localStorage.getItem("ImsToken")) 
  const [PreLoader, setPreLoader] = useState(true);

    
  let onlineUser = jwtDecode(ImsToken)
  // console.log("onlineUser", onlineUser.role[0].name)
  const AllStores = async () => {
    let result = await GetAllStores()

    console.log("allstores", result)
    
   

    if (result.status == true) {
      setStore(result.queryresult)
      setPreLoader(false)

    }
  }


  const [DashboardData, setDashboardData] = useState([]);
  const [DashboardDataBar, setDashboardDataBar] = useState([]);

  const DashboardRecord = async () => {
    let result = await GetDashboard()

    console.log("dashboard", result);

    if (result.status == true) {
      setDashboardData(result)
      setDashboardDataBar(result.peindingscnbystoredetals)
      setPreLoader(false)

    }
  }
  const urlData = (input) => {
    if (input == "accountapproved") {
      return '//pick-up-group'
    }
    else if (input == "PendingI&QA") {
      return '/quality-inspection'
    } else if (input == "Inspected") {
      return '/inventory-account'
    } else {
      return '/dashboard'
    }
  }

  
  const Data = [
    {  name: "Admin Store SRA Total", value: DashboardData.sradminstoreacount  },
    {  name: "Central circle Store SRA Total", value: DashboardData.sracentralcirclestorecount  },
    {  name: "East circle Store SRA Total", value: DashboardData.sraeastcirclestorecount  },
    {  name: "West circle Store SRA Total", value: DashboardData.srawestcirclestorecount  },
   

  ]
  const DataSCN = [
    {  name: "Admin Store scn Total", value: DashboardData.scndminstorecount  },
    {  name: "Central circle Store scn Total", value: DashboardData.scncentralcirclestorecount  },
    {  name: "East circle Store scn Total", value: DashboardData.scneastcirclestorecount  },
    {  name: "West circle Store scn Total", value: DashboardData.scnwestcirclestorecount  },
   

  ]
  const DataSRAInventory = [

    {  name: " Total Pending Inventory Account", value: DashboardData.srainspectedcount  },
    {  name: " Total Rejected Inventory Account", value: DashboardData.sraaccountrejectedcount  },
    {  name: " Total Approved Inventory Account ", value: DashboardData.scneastcirclestorecount  },
   

  ]
  const DataSRAIQA = [

    {  name: " Total Pending I&QA", value: DashboardData.srapendingiandqacount  },
    {  name: " Total Rejected I&QA", value: DashboardData.sraiandqarejectedcount  },
    {  name: " Total Approved I&QA ", value: DashboardData.srainspectedcount  },
   

  ]




  useEffect(() => {
    DashboardRecord()
    AllStores()
    var reloadCount = localStorage.getItem("reloadCount");
    if(!reloadCount){
      localStorage.setItem('reloadCount', + parseInt(1))

    }
    if(reloadCount < 2) {
      localStorage.setItem('reloadCount', parseInt(reloadCount) + 1);
      setTimeout(() =>
      window.location.reload(1), 2000)
    } else {
      localStorage.removeItem('reloadCount');
    }

    
  
  
   
  }, []);

  return (
    <MainLayout>
     {
                PreLoader && (

                    <Preloader/>
                )
            }
      <Seo title="Dashboard" description='EKO IMS - Dashboard' />
      <Text display={"flex"} justifyContent="flex-end" fontWeight={"600"} pb="9px">{onlineUser?.role[0].name}</Text>
      <Box bgColor={"blue.blue350"} rounded={"8px"} p="20px">
        <Flex justifyContent={"space-between"} flexWrap="wrap">
          <DashboardBox link={"/track-sra-status"} title="Admin SRA" details={DashboardData.sratotalcount} />
          <DashboardBox link={"/track-sra-status"} title="Request" details={DashboardData.requesttotalcount} />
          <DashboardBox link={"/track-sra-status"} title="SCN " details={DashboardData.scntotalcount} />
          <DashboardBox link={"/track-sra-status"} title="Inspected SCN" details={DashboardData.scninspectedcount} />
          <DashboardBox link={"/pick-up-group"} title="Admin  Request " details={DashboardData.requestadminstorecount} />
          <DashboardBox link={"/pick-up-group"} title="Technical  Request " details={DashboardData.requesttechstorecount} />
          <DashboardBox link={"/pick-up-group"} title="Pending Admin Request " details={DashboardData.requestpendingadminstorecount} />
          <DashboardBox link={"/pick-up-group"} title="Pending Tech Request " details={DashboardData.requestpendingtechstorecount} />
         
        </Flex>
      </Box>
      <Text textAlign={"center"} fontWeight="600" mt="20px" fontSize={"20px"}>Summary</Text>
      <Flex flexDir={["column", "column", "row", "row"]} pb="22px" mt="20px" justifyContent={"space-around"} alignItems="center" overflowX={"auto"}>
      <Box >
      <Text textAlign={"center"} fontWeight="600" mt="20px" fontSize={"20px"}>All Store SRA Break Down</Text>
      <BarChart width={500} height={300} data={Data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }} barSize={20} label>
            <XAxis dataKey="name" scale={"point"} padding={{ left: 10, right: 10 }} />
            <YAxis />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey={"value"} fill="green" background={{ fill: "#ddd" }} />

          </BarChart>
      </Box>
      <Box >
      <Text textAlign={"center"} fontWeight="600" mt="20px" fontSize={"20px"}>All Store SCN Break Down</Text>

          <BarChart width={500} height={300} data={DataSCN} margin={{ top: 5, right: 30, left: 20, bottom: 5 }} barSize={20} label>
            <XAxis dataKey="name" scale={"point"} padding={{ left: 10, right: 10 }} />
            <YAxis />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey={"value"} fill="green" background={{ fill: "#ddd" }} />

          </BarChart>

        </Box>

      


      </Flex>
      <Flex flexDir={["column", "column", "row", "row"]} pb="22px" mt="20px" justifyContent={"space-around"} alignItems="center" overflowX={"auto"}>
      <Box>
      <Text textAlign={"center"} fontWeight="600" mt="20px" fontSize={"20px"}>All SRA Inventory Account Break Down</Text>
      <BarChart width={500} height={300} data={DataSRAInventory} margin={{ top: 5, right: 30, left: 20, bottom: 5 }} barSize={20} label>
            <XAxis dataKey="name" scale={"point"} padding={{ left: 10, right: 10 }} />
            <YAxis />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey={"value"} fill="green" background={{ fill: "#ddd" }} />

          </BarChart>
      </Box>
      <Box>
      <Text textAlign={"center"} fontWeight="600" mt="20px" fontSize={"20px"}>All SRA I&QA Break Down</Text>

          <BarChart width={500} height={300} data={DataSRAIQA} margin={{ top: 5, right: 30, left: 20, bottom: 5 }} barSize={20} label>
            <XAxis dataKey="name" scale={"point"} padding={{ left: 10, right: 10 }} />
            <YAxis />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey={"value"} fill="green" background={{ fill: "#ddd" }} />

          </BarChart>

        </Box>

      


      </Flex>
     


    </MainLayout>
  )
}
